import JSZip from 'jszip';

export type ExportFile = { blob: Blob; filename: string };

export async function downloadAsZip(
  items: ExportFile[],
  zipName: string,
): Promise<void> {
  const zip = new JSZip();
  items.forEach(({ blob, filename }) => zip.file(filename, blob));
  const zipBlob = await zip.generateAsync({ type: 'blob' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(zipBlob);
  link.download = `${zipName}.zip`;
  link.click();
  URL.revokeObjectURL(link.href);
}

export function downloadFile({ blob, filename }: ExportFile): void {
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  link.click();
  URL.revokeObjectURL(link.href);
}
